__turbopack_context__.v({
  "lc-clamped-text": "ClampedText-module__WoBB2q__lc-clamped-text",
});
